import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Menu} from "antd";
import {connect} from "react-redux";
import SidebarMenuItem from "./SidebarMenuItem";
import {propertyIsDefined} from "../utils";

const mapStateToProps = state => ({
    isSidebarCollapsed: state.app.isSidebarCollapsed,
    nodeId: state.app.endpointId,
});

const SubChildren = ({
                         child,
                         parent,
                         isSidebarCollapsed,
                         subMenuProps,
                         nodeId,
                         t,
                         tReady,
                         dispatch,
                         ...other
                     }) => {
    if (!child.children) {
        return (
            <SidebarMenuItem child={child} t={t} {...other} />
        )
    }

    return (
        <Menu.SubMenu
            className="sidebar__menu__item"
            key={child.path}
            title={
                <div
                    title={(propertyIsDefined(isSidebarCollapsed) ? isSidebarCollapsed : true) ? t(child.label) : null}>
                    <div className="sidebar__menu__item__icon__container">
                        <img
                            alt={t(child.label)}
                            className="sidebar__menu__item__icon"
                            src={child.redIconPath}
                        />
                    </div>
                    <span className="sidebar__menu__item__label">
                        {t(child.label)}
                    </span>
                </div>
            }
            {...subMenuProps} {...other}>
            {
                child.children.map(subChild =>
                    <SidebarMenuItem key={subChild.path} child={subChild} t={t} {...other} />
                )
            }
        </Menu.SubMenu>
    )
}

export default compose(translate(), connect(mapStateToProps))(SubChildren)